var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanesDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 576,
    height: 339,
    viewBox: "0 0 576 339",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M455.625 197.448C362.909 309.728 187 167.722 122 360.722",
    stroke: "#292B2E",
    strokeWidth: 1.4211,
    strokeLinecap: "round",
    strokeDasharray: "6.94 6.94"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M292.743 87.5802C141.976 184.98 383.434 310.984 122 392.722",
    stroke: "#292B2E",
    strokeWidth: 1.4211,
    strokeLinecap: "round",
    strokeDasharray: "6.23 6.23"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M459.331 190.631L453.005 161.481L524.436 110.76L459.331 190.631Z",
    fill: "#292B2E",
    stroke: "#292B2E",
    strokeWidth: 1.18425,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M459.331 190.631L466.771 170.934L524.29 110.792L459.331 190.631Z",
    fill: "white",
    stroke: "#292B2E",
    strokeWidth: 1.18425,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M454.131 167.476L420.96 157.413C419.954 157.108 419.877 155.715 420.842 155.3L524.371 110.774L454.131 167.476Z",
    fill: "white",
    stroke: "#292B2E",
    strokeWidth: 1.18425,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M506.5 180.404L466.771 170.82L524.289 110.792L507.86 179.57C507.715 180.177 507.106 180.55 506.5 180.404Z",
    fill: "white",
    stroke: "#292B2E",
    strokeWidth: 1.18425,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M313.96 55.6074L300.132 83.4712L425.165 26.5254L313.96 55.6074Z",
    fill: "#292B2E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M299.657 84.5549C299.51 84.4907 299.378 84.3974 299.269 84.2806C299.159 84.1638 299.074 84.026 299.02 83.8756C298.965 83.7251 298.941 83.5651 298.95 83.4053C298.959 83.2455 299.001 83.0891 299.072 82.9457L312.9 55.0816C312.975 54.9301 313.082 54.7966 313.213 54.6899C313.344 54.5832 313.496 54.5058 313.66 54.4629L424.865 25.3814C425.152 25.3065 425.456 25.3419 425.717 25.4804C425.979 25.619 426.179 25.8507 426.279 26.1297C426.378 26.4088 426.369 26.7149 426.253 26.9875C426.137 27.2601 425.924 27.4795 425.654 27.6022L300.622 84.548C300.47 84.6169 300.306 84.6531 300.14 84.6543C299.974 84.6555 299.809 84.6216 299.657 84.5549ZM314.779 56.6156L302.671 81.0158L412.159 31.1493L314.779 56.6156Z",
    fill: "#292B2E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M428.727 24.9449L335.923 114.499L314.162 56.1269L284.166 21.0631L428.727 24.9449Z",
    fill: "white",
    stroke: "#292B2E",
    strokeWidth: 1.18425
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M313.61 54.7945L319.016 68.8904L427.766 25.2791L313.61 54.7945Z",
    fill: "#292B2E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M320.315 74.3552L318.526 69.2171L302.13 82.6247L320.315 74.3552Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanesDesktop);
export default __webpack_public_path__ + "static/media/planes-desktop.d57d4f03b2bad7c91b3de6a5d52af32f.svg";
export { ForwardRef as ReactComponent };